import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../_services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../_models/user';

@Component({
    selector: 'app-billing-history',
    templateUrl: './billing-history.component.html',
    styleUrls: ['./billing-history.component.css'],
    standalone: false
})
export class BillingHistoryComponent implements OnInit {
    subscriptions = [];
    loading = true;
    currentPage = 1;
    totalPages = 1;
    itemsPerPage = 30;
    user: User;

    constructor(
        private titleService: Title,
        private userService: UserService,
        private translateService: TranslateService
    ) {
        this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
    }

    ngOnInit() {
        this.translateService.get('subscription.billing_history').subscribe(value => {
            this.titleService.setTitle(value);
        });
        this.loadSubscriptions();
    }

    loadSubscriptions() {
        this.loading = true;
        this.userService.getSubscriptions().subscribe({
            next: (response: any) => {
                const pagination = response.data || {};
                const allSubscriptions = pagination.data || [];
                
                // Filter out failed payments; SUCCESS = Flutterwave,
                // CONFIRMED = eFarm Mobile Money awaiting admin approval
                this.subscriptions = allSubscriptions.filter((sub: any) =>
                    ['SUCCESS', 'CONFIRMED'].includes(sub.payment?.status) && sub.payment?.paymentDate
                );
                
                this.currentPage = pagination.page || 1;
                this.totalPages = pagination.totalOfPage || 1;
                this.itemsPerPage = pagination.itemPerPage || 30;
                this.loading = false;
            },
            error: () => {
                this.subscriptions = [];
                this.loading = false;
            }
        });
    }

    formatDate(dateString: string): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    getStatusBadgeClass(status: string): string {
        switch (status?.toUpperCase()) {
            case 'ACTIVE':
                return 'badge-success';
            case 'INACTIVE':
                // subscription paid via eFarm MoMo, awaiting admin approval
                return 'badge-warning';
            case 'EXPIRED':
                return 'badge-danger';
            case 'PENDING':
                return 'badge-warning';
            default:
                return 'badge-secondary';
        }
    }

    getPaymentMethodLabel(method: string): string {
        if (!method) return '';
        return method.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
    }

    get hasSubscriptions(): boolean {
        return this.subscriptions.length > 0;
    }
}
